import { useContext, useMemo } from "react"
import PropTypes from "prop-types"
import { isFunction } from "lodash"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { EXPOSURE_CONTEXT } from "./context"

export default function ExposureHeader({ modelMetadata }) {
  const { selectedCategory, setSelectedCategory, selectedMetricDisplay, setSelectedMetricDisplay } = useContext(EXPOSURE_CONTEXT)

  const analytics = useAnalytics()
  const { handleMetricDisplayChange, handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedMetricDisplay,
    setSelectedCategory,
  })

  const displayOptions = useMemo(() => {
    return METRIC_OPTIONS.exposure.map(({ label, secondaryText, ...props }) => ({
      primaryText: label,
      secondaryText: isFunction(secondaryText) ? secondaryText({ isContentSet: false }) : secondaryText,
      ...props,
    }))
  }, [])

  const options = useMemo(
    () => modelMetadata.categories.map(({ id, label }) => ({ id, primaryText: label })),
    [modelMetadata],
  )

  return <>
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={options}
      alignMenu="left"
      disablePortal
    />
    <ListItemDropDown
      label="Display"
      value={selectedMetricDisplay}
      setValue={handleMetricDisplayChange}
      options={displayOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

ExposureHeader.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
}
